// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, ValidateState } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";

// TODO: Change this so it uses the "customSettings.stateCheckoutRestrictions" array
export const PREVENT_CALIFORNIA_STATE = "PreventCaliforniaState";
const XngValidateState: typeof ValidateState = props => {
    const { state } = props.parameter.address;
    if ((props.parameter as { isShippingValidation?: boolean }).isShippingValidation && state?.name === "California") {
        props.addressErrors.state = PREVENT_CALIFORNIA_STATE;
    }
};

addToChainAfter(chain, ValidateState, XngValidateState);
